import React from 'react';
import PropTypes from 'prop-types';
import { TrixEditor } from 'react-trix';
import Trix from "trix";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import update from 'immutability-helper';

// Related Components
import AwsUploader from '../../../modules/aws_uploader';

export default class Wysiwyg extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onReady: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
  }

  static defaultProps = {
    className: 'min-height-200',
    onReady: () => { },
  }

  constructor(props) {
    super(props);
    this.state = {
      html: '',
      text: '',
    }

    this.editor = React.createRef();

    // Disable captions
    Trix.config.attachments.preview.caption = {
      name: false,
      size: false
    }
  }


  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && (this.editor || {}).editor) {
      if (this.state.html === this.props.value) {
        return; // Prevent redundant updates
      }

      this.setState({ html: this.props.value }, () => {
        this.editor.editor.loadHTML(this.props.value || '');
      });
    }
  }

  handleEditorReady = (editor) => {
    const { onReady } = this.props;

    const newEditor = update(this.editor, { editor: { $set: editor } });
    this.editor = newEditor;

    // Start listening for attachment uploads once the editor is ready
    document.addEventListener("trix-attachment-add", (event) => {
      if (event.attachment.file) {
        this.handleUpload(event.attachment)
      }
    });
    onReady();
  }

  handleChange = (html, text) => {
    const { onChange } = this.props;

    // Prevent setting state if the content hasn't changed
    if (this.state.html !== html) {
      this.setState({
        html,
        text
      }, () => onChange(text, html));
    }
  };

  handleUpload = (attachment) => {
    const { onError } = this.props;
    this.setState({ uploading: true }, () => {
      new AwsUploader()
        .presignerPath('/aws/public_presigner', 'uploads/description_images')
        .onProgress((progress) => {
          attachment.setUploadProgress(parseInt(progress * 100))
        })
        .onSuccess(({ url }) => {
          this.setState({ uploading: false }, () => {
            attachment.setAttributes({ url })
          });
        })
        .onError((error) => onError(error))
        .upload(attachment.file, '');
    });
  }

  render() {
    const { value, className, errorMessage } = this.props;
    return (
      <React.Fragment>
        <TrixEditor {...{
          ref: (el) => { this.editor = el },
          className,
          onChange: this.handleChange,
          onEditorReady: this.handleEditorReady,
          value,
        }} />
        {
          errorMessage &&
          <div className='error-message margin-bottom-10'>
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className='margin-right-5'
            />
            {errorMessage}
          </div>
        }
      </React.Fragment>
    )
  }
}